import(/* webpackMode: "eager" */ "/vercel/path0/src/app/collect/page.tsx");
